function showThemeButtons() {
  const { isTeacher } = this.roleInLesson;
  const { displayTopicButtons } = this.buttonsStore;
  if (!isTeacher) {
    displayTopicButtons(true);
  }
}

export default showThemeButtons;
